import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const defaultShopDataStore = create(
  immer((set, get) => ({
    categories: [], // 상품 카테고리
    products: [], // 상품
    shops: [], // 입점업체
    policies: [], // 상품 정책
    coupons: [], // 쿠폰
    promotions: [], // 프로모션
    notices: [], // 공지사항
    events: [], // 이벤트
    provisions: [], // 약관
    settings: null, // 관리자 설정
    faqList: [], // FAQ
    groups: [], // 그룹상품
    actions: {
      setData: (key, value) => set({ [key]: value }),
      getData: (key) => get()[key] || [],
      addData: (key, value) => {
        const originData = get()[key] || [];

        set({ [key]: [...originData, value] });
      },
    },
  }))
);

export const useDefaultShopDataAction = () =>
  defaultShopDataStore((store) => store.actions);
export const useDefaultShopDataStack = () =>
  defaultShopDataStore((store) => {
    const { actions, ...remain } = store;

    return {
      ...remain,
    };
  });
